import * as Common from '@/tenant/common';

export class Payment extends Common.StateObject{
  constructor(){
    super('Payment')
    this.binders.paymentBalance = new Common.ModelBinder(Common.TransferBalance);
    this.binders.suspenseBalance = new Common.ModelBinder(Common.TransferBalance);    
    this.workflowStateId = 1;
  }
  public get actionTooltip() {
    if (this.state == PaymentStatus.ReceiptPostWaiting)　return '計上する場合は【入金確定】をクリックします。';
    else if (this.state == PaymentStatus.ReceiptCompleted) return '内容を修正する場合は【確定取消】をクリックします。';     
    else if (this.state == PaymentStatus.ReceiptClosed) return '内容を修正する場合は【確定取消】をクリックします。';         
    else if (this.state == PaymentStatus.PaymentPostWaiting) return '確定する場合は【支払確定】をクリックします。';     
    else if (this.state == PaymentStatus.PaymentProcessWaiting) return '計上する場合は【支払完了】をクリックします。';         
    else if (this.state == PaymentStatus.PaymentCompleted) return '内容を修正する場合は【支払取消】をクリックします。';             
    else if (this.state == PaymentStatus.PaymentClosed) return '内容を修正する場合は【支払取消】をクリックします。';         
    else return '';
  }    
  public id: number = 0;
  public paymentNo: string = '';
  public paymentFlag: number = 0;
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public pic: string = null;
  public counterpartId: number = 0;
  public counterpart: Common.Counterpart = null;
  public currencyCode: string = null;
  public bookDate: Date = null;
  public exchangeRate: number = null;
  public amountFC: number = 0;
  public commissionAmountFC: number = 0;
  public settlementAmountFC: number = 0;
  public totalWriteoffAmountFC: number = null;
  public paymentBalance: Common.TransferBalance = null;
  public suspenseBalance: Common.TransferBalance = null;  
  public transferJournals: Array<Common.TransferJournal> = new Array();
  public bankAccount: Common.BankAccount = null;
  public commissionTaxCode: string = null;
  public  firmBankingStatus :FirmBankingFlags = FirmBankingFlags.NotApplicable;
  public summary: string = null;
  public remark: string = null;
  public transSid: number = null;
  public suspenseAmountFC: number = 0;

  public copy():any {
    const temp = super.copy() as Payment;
    temp.id = 0;
    return temp;
  }
  public get messageOnDelete():string {
    switch(this.state){
      case PaymentStatus.PaymentProcessWaiting:
      case PaymentStatus.PaymentCompleted:
      case PaymentStatus.PaymentClosed:        
        return 'ワークフローが進行しているため削除できません。\r\nワークフローのボタンを操作し、状態を「支払確定待ち」に戻してから削除してください。';
      case PaymentStatus.ReceiptCompleted:
      case PaymentStatus.ReceiptClosed:        
        return 'ワークフローが進行しているため削除できません。\r\nワークフローのボタンを操作し、状態を「入金確定待ち」に戻してから削除してください。';
      default: return super.messageOnDelete;
    }
  }
}

export enum PaymentFlags
{
  SendPurchaseOrder = 1,
  SendPurchaseDelivery = 2,
  SendPurchaseCharge = 4,
  SendSalesCharge = 8,
  Send = SendPurchaseOrder | SendPurchaseDelivery | SendPurchaseCharge | SendSalesCharge,
  ReceiveSalesOrder = 16,
  ReceiveAloneInvoice = 32,
  ReceiveCarryOverInvoice = 64,
  Receive = ReceiveSalesOrder | ReceiveAloneInvoice | ReceiveCarryOverInvoice,
  None = 128,
}
export enum FirmBankingFlags
{
    /// <summary>
    /// 対象外
    /// </summary>
    NotApplicable = 1,
    /// <summary>
    /// 出力対象
    /// </summary>
    Applicable = 2,


    All = NotApplicable | Applicable 
}
export enum PaymentStatus
{
  Receipt = 1,
  Payment = 2,

  ReceiptPostWaiting = Receipt + 16,
  ReceiptCompleted = Receipt + 32,
  ReceiptClosed = Receipt + 64,
  ReceiptNotClosed = ReceiptPostWaiting | ReceiptCompleted,
  PaymentPostWaiting = Payment + 16,
  PaymentProcessWaiting = Payment + 32,
  PaymentCompleted = Payment + 64,
  PaymentClosed = Payment + 128,
  PaymentNotClosed = PaymentPostWaiting | PaymentProcessWaiting  | PaymentCompleted
}

export class SendPayment extends Payment{
  constructor(){
    super()
    this.paymentFlag = PaymentFlags.Send;
    this.workflowCode="sendPayment";
    this.state = PaymentStatus.PaymentPostWaiting;
    this.workflowStateId = PaymentStatus.PaymentPostWaiting;
  }
}

export class ReceivePayment extends Payment{
  constructor(){
    super()
    this.paymentFlag = PaymentFlags.Receive;
    this.workflowCode="receivePayment";
    this.state = PaymentStatus.ReceiptPostWaiting;
    this.workflowStateId = PaymentStatus.ReceiptPostWaiting;
  }
}

export class PaymentQuery extends Common.LoadQuery {
  constructor(paymentFlag: Common.PaymentFlags){
    super('PaymentQuery',Payment);
    this.paymentFlag = paymentFlag;
    this.state = (paymentFlag & PaymentFlags.Receive) > 0 ? PaymentStatus.ReceiptNotClosed : PaymentStatus.PaymentNotClosed;
    this.sort = 'paymentNo';
  }
  public paymentFlag: PaymentFlags = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public bankAccount: Common.BankAccount = null;
  public currencyCode:string = null;
  public pic: string = null;
  public paymentNo: string = null;
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.PaymentStatus = null;
  public holder: string = null;
  public firmBankingStatus : FirmBankingFlags = FirmBankingFlags.All;
  public description : string = null;
}

export class PaymentImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, isSend:boolean){
    super("",null);
    this.className = "PaymentImportQuery";
    this.sheetName = sheetName;
    this.isSend = isSend;
  }
  public sheetName  :string;
  public isSend : boolean;
}
export class PaymentExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, isSend:boolean){
    super("",loadQuery);
    this.className = "PaymentExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.isSend = isSend;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
  public isSend : boolean;
  public hasLicenseCurrency: boolean = false;
}

//全銀ファイル出力用のクエリ
export class FBFileExportQuery extends Common.Query {
  constructor(sheetName:string, payments : Common.Payment[]){
    super("",null);
    this.className = "FBFileExportQuery";
    this.sheetName = sheetName;
    this.payments = payments;
  }
  public sheetName  :string;  
  public payments : Common.Payment[] = null;

}
export class TransferJournalQuery extends Common.LoadQuery{
  constructor(){
    super('TransferJournalQuery',Payment);
  }
  public payment: Payment = null;
}

export class PaymentJournalQuery extends Common.LoadQuery {
  constructor(){
        super('PaymentJournalQuery',Common.Payment);
    }
    public voucherNo: string = '';
    public isSend: boolean = false;
}

export class PaymentJournalTargetQuery extends Common.Query {
  constructor(payment: Common.Payment, isSuspense:boolean){
        super('PaymentJournalTargetQuery',new Common.ModelBinder(Common.TransferJournal, true));
        this.payment = payment;
        this.isSuspense = isSuspense;        
    }
    public payment : Common.Payment;
    public isSuspense:boolean;
}
export class PaymentJournalUpdateQuery extends Common.Query {
  constructor(payment: Common.Payment,isSuspense:boolean, isDelete:boolean, journals : Array<Common.TransferJournal>){
        super('PaymentJournalUpdateQuery',new Common.ModelBinder(Common.Payment, false));
        this.payment = payment;
        this.isDelete = isDelete;        
        this.isSuspense = isSuspense;
        this.journals = journals;
    }
    public payment : Common.Payment;
    public journals : Array<Common.TransferJournal>;
    public isDelete:boolean;
    public isSuspense: boolean;
}

export class BulkPaymentJournalUpdateQuery extends Common.Query {
  constructor(payments: Array<Common.Payment>) {
    super('BulkPaymentJournalUpdateQuery', new Common.ModelBinder(Common.Payment, true));
    this.payments = payments;
  }
  public payments: Array<Common.Payment>;
}

export class GetMoneyLookPaymentQuery extends Common.Query {
  constructor(){
    super('GetMoneyLookPaymentQuery',null);
  }
  public startDate: Date;
  public endDate: Date;
}